import { useQuery } from '@tanstack/react-query'
import { useAuth } from 'src/contexts/auth'
import { RecordController } from 'src/controllers/record.controller'
import { PendingRecordDTO, ILotRecord, IAnimalRecord, ISaleRecord } from 'src/dto/record.dto'

// Mapeia as tabelas para seus tipos correspondentes
type TableTypeMapping = {
  Lote: ILotRecord
  Animal: IAnimalRecord
  VendaAnimal: ISaleRecord
  // Adicione outras tabelas conforme necessário
}

// Tipo condicional que retorna o tipo correto baseado na tabela
type GetRecordType<T extends keyof TableTypeMapping> = PendingRecordDTO<TableTypeMapping[T]>

const recordController = new RecordController()

export function useGetPendingRecord<T extends keyof TableTypeMapping>(
  table?: T,
  recordId?: string
): ReturnType<typeof useQuery<GetRecordType<T>, Error>>

export function useGetPendingRecord(table?: string, recordId?: string) {
  const { userFarm: farmId } = useAuth()

  return useQuery<PendingRecordDTO, Error>({
    queryKey: ['getRecordFromTableById', table, recordId],
    queryFn: () => recordController.getRecordFromTableById(table!, farmId!, recordId!),
    enabled: !!farmId && !!recordId && !!table,
    staleTime: 0,
    retry: true,
    throwOnError: false
  })
}
